import React, { ReactElement } from 'react';

interface CardActionProps {
    label: string;
    icon?: React.ReactElement;
    onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

function CardAction({ label, icon, onClick }: CardActionProps): ReactElement {
    return (
        <button
            type="button"
            className="w-full px-4 py-2 hover:bg-indigo-50 cursor-pointer flex items-center"
            onClick={onClick}
        >
            <span className="text-ce-gray-500">{icon}</span>
            <span className={`${icon ? 'ml-3' : ''} text-ce-gray-500 text-xs font-bold`}>
                {label}
            </span>
        </button>
    );
}

export default CardAction;
